/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Group_A_FallbackInputs */

const en_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group A`)
};

const fr_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe A`)
};

const de_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe A`)
};

const it_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo A`)
};

const ru_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа А`)
};

const es_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo A`)
};

const zh_cn2_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A组`)
};

const ja_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループA`)
};

const hi_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह ए`)
};

const pt_pt2_compare_event_groups_group_a_fallback = /** @type {(inputs: Compare_Event_Groups_Group_A_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo A`)
};

/**
* | output |
* | --- |
* | "Group A" |
*
* @param {Compare_Event_Groups_Group_A_FallbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_group_a_fallback = /** @type {((inputs?: Compare_Event_Groups_Group_A_FallbackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Group_A_FallbackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_group_a_fallback(inputs)
	if (locale === "de") return de_compare_event_groups_group_a_fallback(inputs)
	if (locale === "it") return it_compare_event_groups_group_a_fallback(inputs)
	if (locale === "ru") return ru_compare_event_groups_group_a_fallback(inputs)
	if (locale === "es") return es_compare_event_groups_group_a_fallback(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_group_a_fallback(inputs)
	if (locale === "ja") return ja_compare_event_groups_group_a_fallback(inputs)
	if (locale === "hi") return hi_compare_event_groups_group_a_fallback(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_group_a_fallback(inputs)
	return en_compare_event_groups_group_a_fallback(inputs)
});